import { Button, Modal } from '@mantine/core';
import React from 'react';

import { ModalBody, ModalFooter } from '@portals/core';

interface EditModeConfirmationModalProps {
  opened: boolean;
  onCancel: () => void;
  onDiscard: () => void;
  onConfirm: () => void;
}

export function EditModeConfirmationModal({
  opened,
  onCancel,
  onConfirm,
  onDiscard,
}: EditModeConfirmationModalProps) {
  return (
    <Modal opened={opened} title="Save Changes?" onClose={onCancel}>
      <ModalBody>
        You have unsaved changes. Would you like to save them?
      </ModalBody>
      <ModalFooter position="right">
        <Button variant="white" color="dark" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="default" onClick={onDiscard}>
          Discard Changes
        </Button>
        <Button onClick={onConfirm}>Save</Button>
      </ModalFooter>
    </Modal>
  );
}
